import { tw as a } from "../../utils/tailwind.js";
var d = /* @__PURE__ */ ((r) => (r.ExtraSmall = "extra-small", r.Small = "small", r.Medium = "medium", r.Large = "large", r.ExtraLarge = "extra-large", r))(d || {});
const m = {
  "extra-small": a`w-160`,
  small: a`w-160 md:w-256`,
  medium: a`w-256 md:w-[22rem]`,
  large: a`w-256 md:w-448`,
  "extra-large": a`w-256 md:w-[34rem]`
}, l = {
  narrow: a`w-160`,
  standard: a`w-256`
}, s = {
  narrow: a`md:w-160`,
  standard: a`md:w-256`,
  wide: a`md:w-[22rem]`,
  wider: a`md:w-448`,
  widest: a`md:w-[34rem]`
};
var w = /* @__PURE__ */ ((r) => (r.Narrow = "narrow", r.Standard = "standard", r.Wide = "wide", r.Wider = "wider", r.Widest = "widest", r))(w || {}), e = /* @__PURE__ */ ((r) => (r.Narrow = "narrow", r.Standard = "standard", r))(e || {});
const o = 600;
export {
  w as DesktopWidthEnum,
  e as MobileWidthEnum,
  o as SCROLL_ANNOUNCEMENT_DELAY,
  d as SizesEnum,
  m as cardWidths,
  s as desktopCardWidths,
  l as mobileCardWidths
};
